import PhoneNumber from 'awesome-phonenumber';

// Country list for the dropdown, derived at runtime instead of vendoring the
// ~240-entry table vue-tel-input v4 hardcoded. Regions + calling codes come
// from awesome-phonenumber (already a dependency); display names come from the
// built-in Intl.DisplayNames. Shape matches what the component expects:
// { name, iso2, dialCode, priority, areaCodes }.
const regionNames = new Intl.DisplayNames(['en'], { type: 'region', fallback: 'code' });

export default PhoneNumber.getSupportedRegionCodes()
  .filter((iso2) => /^[A-Z]{2}$/i.test(iso2))
  .map((iso2) => ({
    name: regionNames.of(iso2.toUpperCase()) || iso2.toUpperCase(),
    iso2: iso2.toUpperCase(),
    dialCode: String(PhoneNumber.getCountryCodeForRegionCode(iso2)),
    priority: 0,
    areaCodes: null,
  }))
  .filter((country) => country.dialCode && country.dialCode !== '0')
  .sort((a, b) => a.name.localeCompare(b.name));
